<script setup>
import {useMutation} from "@tanstack/vue-query";
import {axiosDownloadFile} from "@/composables/downloadFile";
import {computed} from "vue";
import {useStore} from "vuex";
import {errorToast} from "@/composables/useToasts";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import axios from 'axios';

const props = defineProps({
  fromDate: {
    type: String,
    required: true,
  },
  toDate: {
    type: String,
    required: true,
  },
});

const store = useStore();
const userIds = computed(() => store.getters['actions/completedByFilter'].filter((user) => user.active).map((user) => user.id));

const {mutate: exportCompletedActionsCSV, isPending: csvPending} = useMutation({
  mutationFn: async () => {
    await axiosDownloadFile(
      '/ajax/v2/actions/export/csv/completed',
      'POST',
      {
        ...props,
        userIds: userIds.value
      }
    );
  },
  onError: () => {
    errorToast('Something went wrong generating the CSV');
  }
});

const {mutate: exportCompletedActionsPDF, isPending: pdfPending} = useMutation({
  mutationFn: async () => {
    const {data} = await axios.post(
      '/ajax/v2/actions/export/pdf/completed',
      {
        ...props,
        userIds: userIds.value
      }
    );

    window.open(data.data.url, '_blank');
  },
  onError: () => {
    errorToast('Something went wrong generating the PDF');
  }
});
</script>

<template>
  <div class="tw-flex tw-gap-6 tw-text-grey-dark tw-items-center tw-text-base tw-font-bold">
    Export:
    <div class="tw-flex tw-gap-2 tw-items-center">
      <SquareIconButton
        variant="primary-inverted"
        size="small"
        :loading="pdfPending"
        :disabled="pdfPending"
        @click="exportCompletedActionsPDF"
      >
        <svg-vue
          icon="icons/pdf"
          class="tw-w-6"
        />
      </SquareIconButton>

      <SquareIconButton
        variant="primary-inverted"
        size="small"
        :loading="csvPending"
        :disabled="csvPending"
        @click="exportCompletedActionsCSV"
      >
        <svg-vue
          icon="icons/csv"
          class="tw-w-6"
        />
      </SquareIconButton>
    </div>
  </div>
</template>
